import ContentBody from '@op/components/ContentBody';
import {
  ReportPermissionProvider,
  parseReportOwnerQuery,
} from '@op/components/ReportPermission';
import useLanguage from '@op/hooks/useLanguage';
import React, { useMemo } from 'react';
import { Layout, TabPanel, Tabs } from 'tea-component';
import { connect, useLocation } from 'umi';
import SavedAnalysisList from './pages/SavedAnalysisList';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';
import { URLAnalysis, URLAnalysisList } from '@op/operationLog/pages';
import useTabHistory from '@op/hooks/useTabHistory';
import URLCardAnalysis from './pages/URLCardAnalysis';
import { PAGE_NAME } from '@op/constants/page';
import './scss/page.scss';

const { Content } = Layout;
interface IKeywordAndURLDrill {
  gameInfo: any;
  filter: any;
  wholeGameInfo: any;
  userInfo: any;
}

const KeywordAndURLDrill = ({
  gameInfo,
  wholeGameInfo,
  userInfo,
}: IKeywordAndURLDrill) => {
  const { formatMessage } = useLanguage();
  const location = useLocation<{ query?: { owner?: string } }>();
  const initialOwner = useMemo(
    () => parseReportOwnerQuery(location?.query?.owner),
    [location?.query?.owner],
  );
  const { tab: activeId, onActive } = useTabHistory({
    defaultValue: 'createAnalysis',
  });

  useInitBuriedPointInfo({
    buriedPoint:
      activeId === 'savedAnalysisList' ? URLAnalysisList : URLAnalysis,
  });

  const tabs = useMemo(
    () => [
      {
        id: 'createAnalysis',
        label: formatMessage({
          id: 'Create Analysis',
        }),
      },
      {
        id: 'savedAnalysisList',
        label: formatMessage({
          id: 'Saved Analysis List',
        }),
      },
    ],
    [formatMessage],
  );

  return (
    <ReportPermissionProvider
      notificationMode={activeId === 'savedAnalysisList' ? 'list' : 'create'}
    >
      <Content className="dbo-page dbo-page-keyword-url-drill">
        <ContentBody
          pageName={PAGE_NAME.URL_ANALYSIS}
          contentHeard={
            <Content.Header
              className="dbo-header  contentHead-normal"
              title={formatMessage({ id: PAGE_NAME.URL_ANALYSIS })}
            >
              <div className="header-tab">
                <Tabs
                  ceiling
                  tabs={tabs}
                  animated={false}
                  activeId={activeId}
                  onActive={onActive}
                />
              </div>
            </Content.Header>
          }
        >
          <Tabs
            ceiling
            tabs={tabs}
            animated={false}
            activeId={activeId}
            destroyInactiveTabPanel={false}
            className="dbo-hide-tabs dbo-header-tab"
            onActive={onActive}
          >
            <TabPanel id="createAnalysis">
              <URLCardAnalysis
                gameInfo={gameInfo}
                userInfo={userInfo}
                wholeGameInfo={wholeGameInfo}
                changeTab={() => onActive({ id: 'savedAnalysisList' })}
              ></URLCardAnalysis>
            </TabPanel>
            <TabPanel id="savedAnalysisList">
              <SavedAnalysisList
                gameInfo={gameInfo}
                wholeGameInfo={wholeGameInfo}
                isKeyword={false}
                categoryType="url"
                needRequest={activeId === 'savedAnalysisList'}
                initialOwner={initialOwner}
              ></SavedAnalysisList>
            </TabPanel>
          </Tabs>
        </ContentBody>
      </Content>
    </ReportPermissionProvider>
  );
};

export default connect((state: any) => {
  const { opinionCommon, opinionFilter, home } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
    userInfo: home.userInfo,
  };
})(KeywordAndURLDrill);
